import {
  FETCH_TEMPLATE_REQUEST, FETCHING_TEMPLATE_SUCCEEDED, FETCHING_TEMPLATE_FAILED,
  CREATE_STORYBOARD_FROM_TEMPLATE, CREATING_STORYBOARD_FROM_TEMPLATE_SUCCEEDED, CREATING_STORYBOARD_FROM_TEMPLATE_FAILED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const TEMPLATES_URL = `${apiUrl}/api/2.0/templates`;


/**
 * Fetch templates
*/
export const fetchTemplates = createAction(FETCH_TEMPLATE_REQUEST, (page, limit, request) => {
  return {
    page: page,
    limit: limit,
    request: request
  };
});

const fetchingTemplatesSucceeded = createAction(FETCHING_TEMPLATE_SUCCEEDED, (response) => {
  return response
});

const fetchingTemplatesFailed = createAction(FETCHING_TEMPLATE_FAILED, (error) => {
  return error;
});

function* fetchTemplatesSaga(action) {
  const {page, limit, request} = action.payload;
  
  const queryParams = {
    page: page,
    limit: limit
  }

  let url = buildUrl(TEMPLATES_URL, {
    queryParams: queryParams
  });

  const fetchTemplatesAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchTemplatesAPI);
    yield put(fetchingTemplatesSucceeded(response));
  } catch (error) {
    yield put(fetchingTemplatesFailed(error));
  }
}

/**
 * Create storyboard from template
*/
export const createStoryboardFromTemplate = createAction(CREATE_STORYBOARD_FROM_TEMPLATE, (name, template) => {
  return {
    name: name,
    template: template
  };
});

const creatingStoryboardFromTemplateSucceeded = createAction(CREATING_STORYBOARD_FROM_TEMPLATE_SUCCEEDED, (response) => {
  return response
});

const creatingStoryboardFromTemplateFailed = createAction(CREATING_STORYBOARD_FROM_TEMPLATE_FAILED, (error) => {
  return error;
});


function* createStoryboardFromTemplateSaga(action) {
  
}

export default function* templateSaga() {
  yield takeEvery(FETCH_TEMPLATE_REQUEST, fetchTemplatesSaga);
}